import React from 'react';

import { Menu } from '@randajan/jet-react/dom/menu';



import { MenuLink } from '../MenuLink/MenuLink';
import { Router } from '../../../pages';
import "./PageMenu.scss";
import { Locale } from '../../../assets/Locale';
import { LocaleButton } from '../../Locales/LocaleButton/LocaleButton';

const MenuIcon = (props)=>{
    const menu = Menu.use();
    return (
        <div className="MenuIcon" onClick={menu.blur}>
            <span/>
            <span/>
            <span/>
        </div>
    );
}

const renderLinks = (say)=>{
    let previousGroup;

    return Router.mapRoutes(({ path, link, menuId, group="main" }, key)=>{
        if (!menuId) { return null; }

        const divider = previousGroup && previousGroup !== group;
        previousGroup = group;

        return (
            <MenuLink className="PageMenu-link" data-divider={divider || undefined} data-group={group} key={key} to={link ?? path}>
                {say(menuId)}
            </MenuLink>
        );
    });
};


export const PageMenu = (props)=>{
    const {} = props;

    const say = Locale.use();

    return (
        <Menu className={["PageMenu"]} trigger={<MenuIcon/>} position="right" transition={500}>
            <div className="PageMenu-locale"><LocaleButton/></div>
            {renderLinks(say)}
            <MenuLink className="PageMenu-link" data-group="secondary" to="#contact=up">{say("navContact")}</MenuLink>
        </Menu>
    )
}

